import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

import Counter from "./counter";
import DbLogin from "./dblogin";
import Devices from "./devices";
import Logo from "./logo";
import Notifications from "./notifications";

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    counter: Counter,
    login: DbLogin,
    devices: Devices,
    logo: Logo,
    notifications: Notifications,
  },
});
